import React from "react";

function ShowIButtonName(props)  {
    return (
        <span>
            {props.ibuttonId !== null && props.serialno !== props.iButtonName && (
                <>{' '}
                    <i className="fa fa-address-card-o" title={`iButton/Driver ID: ${props.serialno}`}> </i>
                    {' '}
                </>
            )}
            {props.ibuttonId !== null && (
                <>{' '}
                    {props.iButtonName}
                </>
            )}
        </span>
    );
}

export default ShowIButtonName